<template>
  <div class="content">
    <p class="ttile">
      热区<span
        >(说明:添加图片，在对应的位置添加上热区，然后双击设置好关联链接保存上架后，用户点击对应的位置，即可跳转到您关联的链接内容。)</span
      >
    </p>
    <div class="set-content">
      <div class="set-item">
        <p class="title">添加热区</p>

        <upload-img-list
          v-model="curComponent.imgs"
          :maxLength="10"
          addBtnText="添加热区"
          :templateParams="{ path: '', imgUrl: '', hotSpots: [] }"
        >
          <template v-slot:childRightContent="{ i }">
            <div class="upload-img-slot">
              <el-button
                v-if="curComponent.imgs[i].hotSpots.length === 0"
                @click="addHotSpot(i)"
                >添加热区</el-button
              >
              <div v-else>
                <p>已添加{{ curComponent.imgs[i].hotSpots.length }}个热区</p>
                <el-button @click="addHotSpot(i)"
                  >编辑<i class="el-icon-edit"></i
                ></el-button>
              </div>
            </div>
          </template>
        </upload-img-list>
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpPickerColor
          v-if="haveBackgroundColorField"
          v-model="curComponent.backgroundColor"
          :isGradient="true"
          label="背景颜色"
        />
        <SpSlider
          v-if="haveRadiusField"
          v-model="curComponent.radius"
          label="图片圆角值"
        />
        <SpSlider v-model="curComponent.pageMx" label="页面间距" />
        <SpSlider v-model="curComponent.imgMy" label="图片边距" />
        <SpSlider v-model="curComponent.mb" label="页面底部间距" />
      </div>
    </div>

    <EditHotSpotDialog
      v-if="visibleHotSpot"
      v-model="visibleHotSpot"
      :item="curComponent.imgs[i]"
      @confirm="confirm"
    />
  </div>
</template>

<script>
import SpSlider from "../../../components/SpSlider";
import SpPickerColor from "../../../components/SpPickerColor";
import EditHotSpotDialog from "./components/EditHotSpotDialog";
import UploadImgList from "../../../components/UploadImgList";
export default {
  components: {
    SpSlider,
    SpPickerColor,
    UploadImgList,
    EditHotSpotDialog
  },
  inject: ["control"],
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    },
    // v1.2.1新增 - start
    haveRadiusField() {
      const flag = "radius" in this.curComponent;
      if (!flag) {
        this.$set(this.control.curComponent, "radius", 0);
      }
      return "radius" in this.curComponent;
    },
    haveBackgroundColorField() {
      const flag = "backgroundColor" in this.curComponent;
      if (!flag) {
        this.$set(
          this.control.curComponent,
          "backgroundColor",
          "rgba(255,255,255,0)"
        );
      }
      return "backgroundColor" in this.curComponent;
    }
    // end
  },
  data() {
    return {
      visibleHotSpot: false,
      i: 0
    };
  },
  methods: {
    confirm(list) {
      this.curComponent.imgs[this.i].hotSpots = list;
    },
    addHotSpot(i) {
      const item = this.curComponent.imgs[i];
      if (!item.imgUrl) {
        this.$message.error("请上传图片");
        return;
      }
      this.i = i;
      this.visibleHotSpot = true;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      /deep/ .upload-img-slot {
        flex: 1;
        .el-button {
          padding: 4px 14px;
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          border: none;
          color: #fff;
          background: #2154f4;
        }
        div {
          font-size: 14px;
          color: #333;
          .el-button {
            margin-top: 10px;
          }
        }
      }
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-img {
      margin-top: 30px;
    }

    > .basic-set {
      margin-top: 30px;
      /deep/ .slider-content,
      .picker-color {
        margin-bottom: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/HotSpot/Attr.vue